/**
 * Extract the partition-agnostic session identifier from a messageChainId.
 *
 * messageChainId format: `${streamId}-${streamPartition}-${userIdHex}-${randomPart}`
 * Example: `tv.streamr.eth/gct85u268pm-1-023b98...-16t26`
 *
 * The randomPart (e.g., "16t26") is unique per browser window and doesn't
 * change across partitions, so we use it for session matching.
 */
function extractSessionSuffix(messageChainId) {
    const lastDashIndex = messageChainId.lastIndexOf('-');
    if (lastDashIndex === -1) {
        return messageChainId;
    }
    return messageChainId.substring(lastDashIndex + 1);
}
export function createUserSessionId(userId, messageChainId) {
    const sessionSuffix = extractSessionSuffix(messageChainId);
    return `${userId}:${sessionSuffix}`;
}
